module.exports = __webpack_public_path__ + "media/images/awards-2-4c4d727ce4638b38490988651d53611a.jpg";